/**
 * Iconos de marca para las redes del estudio. Glifo lleno en `currentColor`,
 * sin color de marca — coherente con el design system sobrio.
 *
 * <SocialIcon name="linkedin" size={18} />
 */

const PATHS = {
  linkedin:
    'M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.27V1.73C24 .77 23.2 0 22.22 0z',
  whatsapp:
    'M.06 24l1.69-6.17A11.87 11.87 0 0 1 .17 11.9C.17 5.34 5.5 0 12.06 0a11.82 11.82 0 0 1 8.41 3.49 11.8 11.8 0 0 1 3.48 8.42c0 6.56-5.34 11.9-11.9 11.9a11.9 11.9 0 0 1-5.7-1.45L.06 24zm6.6-3.8c1.68.99 3.28 1.59 5.4 1.59 5.45 0 9.9-4.43 9.9-9.88a9.8 9.8 0 0 0-2.9-7 9.83 9.83 0 0 0-6.99-2.9c-5.46 0-9.9 4.44-9.9 9.9 0 2.22.65 3.89 1.74 5.63l-1 3.66 3.75-.98zm11.36-5.46c-.07-.12-.27-.2-.57-.35-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.9-.79-1.5-1.77-1.67-2.07-.17-.3-.02-.46.13-.6.14-.14.3-.36.45-.53.16-.18.2-.3.3-.5.1-.2.06-.38-.02-.53-.07-.15-.67-1.62-.92-2.22-.24-.57-.48-.5-.67-.5l-.57-.02c-.2 0-.52.08-.8.38-.27.3-1.04 1.02-1.04 2.49 0 1.46 1.07 2.88 1.22 3.07.15.2 2.1 3.21 5.09 4.5.71.3 1.27.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.41z',
};

export default function SocialIcon({ name, size = 18, ...props }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d={d} />
    </svg>
  );
}
